export default __webpack_public_path__ + "static/media/2467.3e227c22.png";